import React from 'react'

import Layout from 'components/shared/Layout'
import LogosList from 'components/shared/LogosList'

import classnames from 'classnames/bind'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const Logos = ({ className, brands = [] }) => {
  return (
    <Layout tag="section" type="maxWidth" className={cx(css.Logos, className)}>
      <Layout type="wrapper" className={css.wrapper}>
        <LogosList brands={brands} />
      </Layout>
    </Layout>
  )
}

export default Logos
